import { render, staticRenderFns } from "./PricingFilterCard.vue?vue&type=template&id=ce37dc36&scoped=true"
var script = {}
import style0 from "./PricingFilterCard.vue?vue&type=style&index=0&id=ce37dc36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce37dc36",
  null
  
)

export default component.exports